export default __webpack_public_path__ + "static/media/teacherIcon.8d92974c.svg";